import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import getSymbolFromCurrency from "currency-symbol-map";
import validator from "validator";
import Stack from "@mui/material/Stack";
import AddCircleOutlineIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/Remove";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteOutline";
import TextField from "@mui/material/TextField";
import { getBranch, getCountry } from "../../data/localSettingsActions";
import Utils from "../../core/Utils";
import { serviceItemActionTypes } from "../reducers/serviceItem/serviceItemActionTypes";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import DecimalEntryField from "./controls/DecimalEntryField";
import { getTaxAmount, getTotalPrice } from "../../helpers/productHelper";
import { OfferTypes, ProductIssueStatus, VisitTypeEnum } from "../../core/Constants";
import { FormControl, TableRow, TableCell, Chip } from "@mui/material";
import ComplimentaryPopup from "./Complimentary";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import ItemDiscountComponent from "./ItemDiscountComponent";
import CompValueEntryField from "./controls/CompValueEntryField";
import CloseIcon from "@mui/icons-material/Close";
import CountryHelper from "../../core/CountryHelper";
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import ErrorIcon from '@mui/icons-material/Error';
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { fontWeight } from "@mui/system";
import NumericTextField from "./controls/NumericTextField";

const actions = {
  incrementAction: "incrementAction",
  decrementAction: "decrementAction",
  editAction: "editAction"
};

const PriceComponent = ({ price, currency, handleActions }) => {
  const handleEditPrice = (value) => {
    handleAction(actions.editAction, value);
  };
  // const handleAction = (action, value) => {
  //   switch (action) {
  //     case actions.decrementAction:
  //       var oldPrice = Utils.ConvertToFloat(price);
  //       if (oldPrice < 1 || oldPrice === 0 || oldPrice === 0.0 || oldPrice === 0.00) {
  //         return;
  //       }
  //       handleActions(Utils.ConvertToFloat((oldPrice - 1.00).toFixed(2)));
  //       break;
  //     case actions.incrementAction:
  //       var oldPrice = Utils.ConvertToFloat(price);
  //       handleActions(Utils.ConvertToFloat((oldPrice + 1.00).toFixed(2)));
  //       break;
  //     case actions.editAction:
  //       handleActions(value);
  //       break;
  //   }
  // };

  const handleAction = (action, value) => {
    switch (action) {
      case actions.decrementAction:
        var oldPrice = Utils.ConvertToFloat(price);
        if (oldPrice <= 1) {
          return;
        }
        var newPrice = Utils.ConvertToFloat((oldPrice - 1.00).toFixed(2));

        if (newPrice <= 0) {
          newPrice = 1;
        }

        handleActions(newPrice);
        break;

      case actions.incrementAction:
        var oldPrice = Utils.ConvertToFloat(price);
        handleActions(Utils.ConvertToFloat((oldPrice + 1.00).toFixed(2)));
        break;

      case actions.editAction:
        var newValue = Utils.ConvertToFloat(value);
        if (newValue <= 0) {
          newValue = 1;
        }

        handleActions(newValue);
        break;
    }
  };
  return (
    <Grid xs={8} sm={2} md={2} lg={2} className="text-right" alignSelf="center">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ marginLeft: "2px" }}
        className="w-100"
      >
        {/* <Button
          onClick={() => handleAction(actions.decrementAction)}
          className="price-btn btn-left"
        >
          <RemoveCircleOutlineIcon fontSize="large" alignSelf="center" />
        </Button> */}
        <Stack direction="row" alignItems="center" className="w-100" style={{ margin: "0" }}>
          <Typography
            level="h6"
            component="h6"
            fontWeight="700"
            fontSize="12px"
            className="currency-symbol"
            style={{ marginRight: "15px" }}
          >
            {getSymbolFromCurrency(currency)}
          </Typography>
          <DecimalEntryField
            fontWeight="600"
            setValue={handleEditPrice}
            className="inputField text-right"
            padding="0"
            sx={{
              wordBreak: "break-word",
              whiteSpace: "normal",
              overflowWrap: "break-word"
            }}
            style={{ margin: 0 }}
            value={price}
            convertToFloat={false}
          />
        </Stack>
        {/* <Button
          onClick={() => handleAction(actions.incrementAction)}
          className="price-btn btn-right"
        >
          <AddCircleOutlineIcon fontSize="large" alignSelf="center" />
        </Button> */}
      </Stack>
    </Grid>
  );
}

const QuantityComponent = ({ quantity, handleActions }) => {
  const handleEditQuantity = (value) => {
    handleAction(actions.editAction, value);
  };
  const handleAction = (action, value) => {
    switch (action) {
      case actions.decrementAction:
        var oldQuantity = Utils.ConvertToFloat(quantity);
        if (oldQuantity <= 0.1) {
          return;
        }

        var newQuantity = Utils.ConvertToFloat((oldQuantity - 1).toFixed(2));
        if (newQuantity <= 0) {
          newQuantity = 1;
        }

        handleActions(newQuantity);
        break;
      case actions.incrementAction:
        var oldQuantity = Utils.ConvertToFloat(quantity);
        handleActions(Utils.ConvertToFloat((oldQuantity + 1).toFixed(2)));
        break;
      case actions.editAction:
        var newValue = Utils.ConvertToFloat(value);
        if (newValue < 0.1) {
          newValue = 1;
        }

        handleActions(newValue);
        break;
    }
  };
  return (
    <Grid xs={4} sm={1} md={1} lg={1} alignSelf="center">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ marginLeft: "2px" }}
        className="w-100"
      >
        {/* <Button
          onClick={() => handleAction(actions.decrementAction)}
          className="price-btn btn-left"
        >
          <RemoveCircleOutlineIcon fontSize="large" alignSelf="center" />
        </Button> */}
        <DecimalEntryField
          label=""
          type="text"
          alignSelf="center"
          variant="outlined"
          value={quantity}
          setValue={handleEditQuantity}
          className="inputField text-right w-100"
          style={{ margin: 0 }}
          max={0}
        />
        {/* <Button
          onClick={() => handleAction(actions.incrementAction)}
          className="price-btn btn-right"
        >
          <AddCircleOutlineIcon fontSize="large" alignSelf="center" />
        </Button> */}
      </Stack>
    </Grid>
  );
}

const CostComponent = ({ cost, handleActions, currency }) => {
  const handleEditCost = (value) => {
    var newValue = Utils.ConvertToFloat(value);
    if (newValue < 0) {
      newValue = 0;
    }
    handleActions(newValue);
  };
  return (
    <Grid xs={2} sm={1} md={1} lg={1} alignSelf="center">
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ marginLeft: "2px" }}
      >
        {/* <Button
          onClick={() => handleAction(actions.decrementAction)}
          className="price-btn btn-left"
        >
          <RemoveCircleOutlineIcon fontSize="large" alignSelf="center" />
        </Button> */}
        <Stack direction="row" alignItems="center" style={{ margin: "0" }}>
          <Typography
            level="h6"
            component="h6"
            fontWeight="700"
            fontSize="12px"
            className="currency-symbol"
            style={{ marginRight: "15px" }}
          >
            {getSymbolFromCurrency(currency)}
          </Typography>
          <DecimalEntryField
            fontWeight="600"
            setValue={handleEditCost}
            className="inputField text-right"
            padding="0"
            sx={{
              wordBreak: "break-word",
              whiteSpace: "normal",
              overflowWrap: "break-word"
            }}
            style={{ "max-width": "150px", margin: 0 }}
            value={cost}
            convertToFloat={false}
          />
        </Stack>
        {/* <Button
          onClick={() => handleAction(actions.incrementAction)}
          className="price-btn btn-right"
        >
          <AddCircleOutlineIcon fontSize="large" alignSelf="center" />
        </Button> */}

      </Stack>
    </Grid>
  )
}

const HSNComponent = ({ HSN, handleActions, serviceItem }) => {
  return (
    <Grid xs={2} sm={1} md={1} lg={1} alignSelf="center">
      {!serviceItem.Service && !serviceItem.Material && !serviceItem.Labour && (Utils.IsNullOrEmptyArray(serviceItem.PackageProductDetails)) && <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ marginLeft: "2px" }}
      >
        <Stack direction="row" alignItems="center" style={{ margin: "0" }}>
          <NumericTextField
            fontWeight="600"
            maxLengthValue={16}
            setValue={(value) => {
              handleActions(value);
            }}
            className="inputField text-right"
            padding="0"
            sx={{
              wordBreak: "break-word",
              whiteSpace: "normal",
              overflowWrap: "break-word"
            }}
            style={{ margin: 0 }}
            value={HSN}
            convertToFloat={false}
          />
        </Stack>

      </Stack>}
    </Grid>
  )
}

const ProductCodeComponent = ({ productCode, handleActions }) => {
  const handleEditProductCode = (e) => {
    handleActions(e.target.value);
  };
  return (

    <Stack direction="row" justifyContent="end" sx={{ margin: "0", textAlign: "right" }}>
      <small>Product Code : &nbsp;</small>
      <span
        style={{ fontWeight: "600" }}
        convertToFloat={false}
      >{productCode}</span>
    </Stack>
  )
}

const BrandNameComponent = ({ brandName, handleActions }) => {
  const handleEditBrand = (e) => {
    handleActions(e.target.value);
  };
  return (
    <Grid xs={2} sm={1} md={1} lg={1} alignSelf="center">
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ marginLeft: "2px" }}
      >
        <Stack direction="row" alignItems="center" style={{ margin: "0" }}>
          <TextField
            fontWeight="600"
            onChange={handleEditBrand}
            className="inputField text-right"
            padding="0"
            sx={{
              wordBreak: "break-word",
              whiteSpace: "normal",
              overflowWrap: "break-word"
            }}
            style={{ margin: 0 }}
            value={brandName}
            convertToFloat={false}
          />
        </Stack>

      </Stack>
    </Grid>
  )
}

const ServiceItem = ({ serviceItem, index, handleAction,
  itemComplimentaryList,
  isDiscount,
  onAddComp,
  onRemoveComp,
  onEditComp,
  taxIncluded,
  isTaxIncludedInvoice,
  isCustomProductEntry,
  setIsEditProduct,
  setSelectedEditProduct,
  isEditProductVisible,
  isFromPurchaseOrder,
  isFromProductIntakes,
  visitType = VisitTypeEnum.Checkout,
}) => {
  const [countryInfo, setCountryInfo] = useState({});
  const [branch, setBranch] = useState({});
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [cost, setCost] = useState(0);
  const [isIndianBusiness, setIsIndianBusiness] = useState(false);

  //Compliment hooks
  const [isViewDiscountIcon, setIsViewDiscountIcon] = useState(false);
  const [showComplimentary, setShowComplimentary] = useState(false);
  const [compType, setCompType] = useState("Discount");
  const [compValue, setCompValue] = useState();
  const [currentComp, setCurrentComp] = useState({});
  const [maxPrice, setMaxPrice] = useState(serviceItem.TotalPrice);
  const [description, setDescription] = useState(serviceItem.Description);
  const [packagesProductDetails, setPackagesProductDetails] = useState();
  const [HSN, setHSN] = useState("");
  const [productCode, setProductCode] = useState("");
  const [brandName, setBrandName] = useState("");


  useEffect(() => {
    initializeComponent();
  }, []);

  const initializeComponent = () => {
    setCountryInfo(getCountry());
    setBranch(getBranch());
    const countryInfo = getCountry();
    const isIndia = CountryHelper.IsBusinessCountryIndia(countryInfo);
    if (isIndia) {
      setIsIndianBusiness(true);
    }
  }

  useEffect(() => {
    setMaxPrice(compType === "Discount" ? 100 : serviceItem.TotalPrice);
  }, [compType]);

  useEffect(() => {
    if (Utils.IsNullOrEmptyObject(serviceItem)) {
      return;
    }
    setPrice(serviceItem.Price.toFixed(2));
    setQuantity(serviceItem.Quantity);
    setCost(serviceItem.Cost.toFixed(2));
    var canAddDiscount =
      Utils.IsNullOrEmptyArray(itemComplimentaryList) ||
      Utils.IsNullOrEmptyArray(
        itemComplimentaryList.filter((i) => i.index === serviceItem.Sequence)
      );
    setPackagesProductDetails(serviceItem.PackageProductDetails);
    setIsViewDiscountIcon(canAddDiscount);
    if (!canAddDiscount) {
      setCurrentComp(
        itemComplimentaryList.find((i) => i.index === serviceItem.Sequence)
      );
    }
    var defaultType = "Discount";
    setCompType(defaultType)
    setCompValue("");
    setDescription(serviceItem.Description);
    setHSN(serviceItem.ProductHSN || "");
    setProductCode(serviceItem.ProductCode || "");
    setBrandName(serviceItem.BrandName || "");
  }, [serviceItem]);

  const handleRemove = () => {
    var action = {
      type: serviceItemActionTypes.Delete,
      value: index,
    };
    handleAction(action);
  };

  const handleEdit = (serviceItem) => {
    isCustomProductEntry(true);
    setIsEditProduct(true);
    setSelectedEditProduct(serviceItem);
  }

  const handlePrice = (newValue, pAction) => {
    switch (pAction) {
      case actions.decrementAction:
      case actions.incrementAction:
        if (!Utils.IsNullOrEmpty(newValue)) {
          newValue = newValue.toFixed(2);
        }
        break;
    }
    var newPrice = Utils.ConvertToFloat(newValue);
    setPrice(newValue);
    if (newPrice === 0) {
      serviceItem.Price = newPrice;
      serviceItem.TotalPrice = 0;
      serviceItem.TaxAmount = 0;
      serviceItem.TotalPriceIncludingTax = 0;
    } else {
      serviceItem.Price = newPrice;
      serviceItem.TotalPrice = serviceItem.Price * serviceItem.Quantity;
      recalculateDiscountOnPriceOrQuantityChange();
      var totalPrice = serviceItem.TotalPrice - serviceItem.DiscountTotal;
      serviceItem.TaxAmount = (totalPrice * serviceItem.TaxPercent) / 100;
      serviceItem.TotalPriceIncludingTax = totalPrice + serviceItem.TaxAmount;
      serviceItem.PriceIncludingTax = totalPrice + serviceItem.TaxAmount;
    }
    setMaxPrice(compType === "Discount" ? 100 : serviceItem.TotalPrice);
    var action = {
      type: serviceItemActionTypes.Edit,
      value: serviceItem,
    };
    handleAction(action);
  };

  const handleQuantity = (newValue) => {
    var newQty = Utils.ConvertToFloat(newValue);
    setQuantity(newValue);
    if (newQty === 0) {
      serviceItem.Quantity = "";
      serviceItem.TotalPrice = 0;
      serviceItem.TaxAmount = 0;
      serviceItem.TotalPriceIncludingTax = 0;
    } else {
      serviceItem.Quantity = newQty;
      serviceItem.TotalPrice = serviceItem.Price * serviceItem.Quantity;
      recalculateDiscountOnPriceOrQuantityChange();
      var totalPrice = serviceItem.TotalPrice - serviceItem.DiscountTotal;
      serviceItem.TaxAmount = (totalPrice * serviceItem.TaxPercent) / 100;
      serviceItem.MunicipalTaxAmount = (totalPrice * serviceItem.MunicipalTaxPercent) / 100;
      serviceItem.TotalPriceIncludingTax = totalPrice + serviceItem.TaxAmount + serviceItem.MunicipalTaxAmount;
      if (visitType === VisitTypeEnum.Jobcard && serviceItem.IssueApprovalRequired && (serviceItem.IssueStatus === ProductIssueStatus.Approved || serviceItem.IssueStatus === ProductIssueStatus.Rejected)) {
        serviceItem.IssueStatus = ProductIssueStatus.Pending;
      }
    }
    setMaxPrice(compType === "Discount" ? 100 : serviceItem.TotalPrice);
    var action = {
      type: serviceItemActionTypes.Edit,
      value: serviceItem,
    };
    handleAction(action);
  };

  const handleCost = (newValue, pAction) => {
    var newCost = Utils.ConvertToFloat(newValue);
    setCost(newValue);
    serviceItem.Cost = newCost;
    var action = {
      type: serviceItemActionTypes.Edit,
      value: serviceItem,
    };
    handleAction(action);
  }

  const handleEditTax = (value) => {
    const regex = /^\d*\.?\d{0,2}$/;
    if (!regex.test(value)) {
      return;
    }
    const newTax = Utils.ConvertToFloat(value);
    serviceItem.TaxPercent = newTax;
    var _taxExcludedPrice = Utils.ConvertToFloat(serviceItem?.Price);
    var _totalPrice = Utils.ConvertToFloat(serviceItem?.PriceIncludingTax);
    var Price = (_taxExcludedPrice * (newTax + 100)) / 100;
    var _taxExcludedPrice = (Price / (newTax + 100)) * 100;
    if (serviceItem?.InclusiveOfTax) {
      _taxExcludedPrice = (_totalPrice / (newTax + 100)) * 100;
      Price = (_taxExcludedPrice * (newTax + 100)) / 100;
      setPrice(_taxExcludedPrice.toFixed(2));
    }
    serviceItem.PriceIncludingTax = Price;
    serviceItem.Price = _taxExcludedPrice;
    var totalpriceIncludingTax = Price * serviceItem.Quantity;
    totalpriceIncludingTax = Number(totalpriceIncludingTax.toFixed(2));
    var totalPrice = _taxExcludedPrice * serviceItem.Quantity;
    var totalAmount = getTaxAmount(
      serviceItem.InclusiveOfTax,
      newTax,
      totalPrice,
      totalpriceIncludingTax
    );
    var taxamount = totalAmount[0];
    serviceItem.TaxAmount = taxamount;
    var totalpriceincludingtax = totalPrice + taxamount;
    serviceItem.TotalPriceIncludingTax = totalpriceincludingtax;
    var totalprice = serviceItem.Price * serviceItem.Quantity;
    serviceItem.TotalPrice = totalPrice;
    recalculateDiscountOnPriceOrQuantityChange();
    var action = {
      type: serviceItemActionTypes.Edit,
      value: serviceItem,
    };
    handleAction(action);
  }

  const handleBrandName = (value) => {
    setBrandName(value);
    serviceItem.BrandName = value;
    var action = {
      type: serviceItemActionTypes.Edit,
      value: serviceItem,
    };
  }

  const handleHsnvalue = (value) => {
    setHSN(value);
    serviceItem.HSN = value;
    var action = {
      type: serviceItemActionTypes.Edit,
      value: serviceItem,
    };
  }

  const handleProductCode = (value) => {
    setProductCode(value);
    serviceItem.ProductCode = value;
    var action = {
      type: serviceItemActionTypes.Edit,
      value: serviceItem,
    };
  }

  const handleCloseComplimentary = () => {
    setShowComplimentary(false);
    setCompValue("");
  };

  const recalculateDiscountOnPriceOrQuantityChange = () => {
    if (
      Utils.IsNullOrEmptyArray(serviceItem.Discounts) ||
      Utils.IsNullOrEmptyArray(itemComplimentaryList) ||
      Utils.IsNullOrEmptyObject(currentComp)
    ) {
      return;
    }
    var itemComp = { ...currentComp };
    serviceItem.DiscountTotal = serviceItem.DiscountTotal - itemComp.discount;
    var serviceItemTotalPrice = serviceItem.TotalPrice;
    var serviceItemDiscountTotal = serviceItem.DiscountTotal;
    var currentDiscountTotal =
      itemComp.type === OfferTypes.PercentDiscount
        ? ((serviceItemTotalPrice - serviceItemDiscountTotal) *
          itemComp.value) /
        100
        : itemComp.value;
    var discountIndex = serviceItem.Discounts.findIndex(
      (d) => d.CampaignId === itemComp.compId
    );
    if (discountIndex === -1) {
      return
    }
    serviceItem.Discounts[discountIndex].DiscountTotal = currentDiscountTotal;
    serviceItem.DiscountTotal =
      serviceItem.DiscountTotal + currentDiscountTotal;
    itemComp.discount = currentDiscountTotal;
    setCurrentComp(itemComp);
    onEditComp(itemComp, itemComplimentaryList.indexOf(itemComp));
  };

  const addComp = () => {
    var compDesc = "Item Complimentary";
    var discountType =
      compType === "Discount" ? OfferTypes.PercentDiscount : OfferTypes.Cash;
    var compDescDetailed =
      compType === "Discount"
        ? "Discount Percentage " + compValue + "%"
        : "Cash Back " + Utils.GetCurrency(compValue, countryInfo);
    var compId = Utils.CreateGuid();
    var discountTotal = !Utils.IsNullOrEmptyArray(itemComplimentaryList)
      ? itemComplimentaryList.map((o) => o.discount).reduce((a, b) => a + b)
      : 0;
    var currentDiscountTotal = 0;
    var newCompValue = parseFloat(compValue);
    if (newCompValue > 0) {
      var serviceItemTotalPrice = serviceItem.TotalPrice;
      var serviceItemDiscountTotal = serviceItem.DiscountTotal;
      currentDiscountTotal =
        discountType === OfferTypes.PercentDiscount
          ? ((serviceItemTotalPrice - serviceItemDiscountTotal) *
            newCompValue) /
          100
          : newCompValue;
      currentDiscountTotal = Utils.ConvertToFloat(
        currentDiscountTotal.toFixed(2)
      );
      discountTotal += currentDiscountTotal;
      var discount = {
        CampaignId: compId,
        BenefitId: "",
        CampaignType: "Advertisement",
        OffersClassificationType: "Campaign",
        BenefitType: "DiscountPercentage",
        Code: compDescDetailed,
        Description: compDesc,
        DescriptionDetail: compDescDetailed,
        Quantity: 0.0,
        Complimentary: true,
        OrderLevel: false,
        PointsRedemption: false,
        DiscountType: discountType,
        DiscountValue: newCompValue,
        DiscountTotal: currentDiscountTotal,
      };
      serviceItem.Discounts.push(discount);
      serviceItem.DiscountTotal = serviceItem.Discounts.map(
        (d) => d.DiscountTotal
      ).reduce((a, b) => a + b);
      var totalPrice = serviceItem.TotalPrice - serviceItem.DiscountTotal;
      var totalpriceIncludingTax =
        (totalPrice * (serviceItem.TaxPercent + 100)) / 100;
      var taxamount = totalpriceIncludingTax - totalPrice;
      serviceItem.TaxAmount = taxamount;
      serviceItem.TotalPriceIncludingTax = totalpriceIncludingTax;
      var newComp = {
        orderLevel: false,
        productId: serviceItem.ProductId,
        index: serviceItem.Sequence,
        value: newCompValue,
        type: discountType,
        discount: currentDiscountTotal,
        compId: compId,
      };
      var action = {
        type: serviceItemActionTypes.Edit,
        value: serviceItem,
      };
      handleAction(action);
      handleCloseComplimentary();
      setIsViewDiscountIcon(false);
      onAddComp(newComp);
      setCurrentComp(newComp);
    }
  };

  const removeComp = (index) => {
    var currentItemComp = itemComplimentaryList.find(
      (c) => c.index === serviceItem.Sequence
    );
    onRemoveComp(currentItemComp);
    serviceItem.Discounts = serviceItem.Discounts.filter(
      (d) => d.CampaignId !== currentItemComp.compId
    );
    serviceItem.DiscountTotal = Utils.IsNullOrEmptyArray(serviceItem.Discounts)
      ? 0
      : serviceItem.Discounts.map((d) => d.DiscountTotal).reduce(
        (a, b) => a + b
      );
    var totalPrice = serviceItem.TotalPrice - serviceItem.DiscountTotal;
    var totalpriceIncludingTax =
      (totalPrice * (serviceItem.TaxPercent + 100)) / 100;
    var taxamount = totalpriceIncludingTax - totalPrice;
    serviceItem.TaxAmount = taxamount;
    serviceItem.TotalPriceIncludingTax = totalpriceIncludingTax;
    var action = {
      type: serviceItemActionTypes.Edit,
      value: serviceItem,
    };
    handleAction(action);
    setCurrentComp({});
    setIsViewDiscountIcon(true);
  };

  const onChangeCompValue = (newValue) => {
    if (Utils.IsNullOrEmptyObject(currentComp)) {
      return;
    }
    var tempCurrentComp = { ...currentComp };
    tempCurrentComp.value = Utils.ConvertToFloat(newValue);
    if (
      !Utils.IsNullOrEmptyArray(serviceItem.Discounts) &&
      serviceItem.Discounts.some((d) => d.CampaignId === tempCurrentComp.compId)
    ) {
      var discountIndex = serviceItem.Discounts.findIndex(
        (d) => d.CampaignId === tempCurrentComp.compId
      );
      serviceItem.Discounts[discountIndex].DiscountValue =
        tempCurrentComp.value;
      var compDescDetailed =
        tempCurrentComp.type === OfferTypes.PercentDiscount
          ? "Discount Percentage " + tempCurrentComp.value + "%"
          : "Cash Back " + tempCurrentComp.value;
      serviceItem.Discounts[discountIndex].DescriptionDetail = compDescDetailed;
      serviceItem.DiscountTotal =
        serviceItem.DiscountTotal - tempCurrentComp.discount;
      var serviceItemTotalPrice = serviceItem.TotalPrice;
      var serviceItemDiscountTotal = serviceItem.DiscountTotal;
      var currentDiscountTotal =
        tempCurrentComp.type === OfferTypes.PercentDiscount
          ? ((serviceItemTotalPrice - serviceItemDiscountTotal) *
            tempCurrentComp.value) /
          100
          : tempCurrentComp.value;
      tempCurrentComp.discount = currentDiscountTotal;
      serviceItem.Discounts[discountIndex].DiscountTotal = currentDiscountTotal;
      serviceItem.DiscountTotal =
        serviceItem.DiscountTotal + currentDiscountTotal;
      var totalPrice = serviceItem.TotalPrice - serviceItem.DiscountTotal;
      var totalpriceIncludingTax =
        (totalPrice * (serviceItem.TaxPercent + 100)) / 100;
      var taxamount = totalpriceIncludingTax - totalPrice;
      serviceItem.TaxAmount = taxamount;
      serviceItem.TotalPriceIncludingTax = totalpriceIncludingTax;
      var action = {
        type: serviceItemActionTypes.Edit,
        value: serviceItem,
      };
      handleAction(action);
    }
    onEditComp(tempCurrentComp, itemComplimentaryList.indexOf(tempCurrentComp));
    setCurrentComp(tempCurrentComp);
  };

  const onChangeCompType = (type) => {
    setCompType(type);
  }
  useEffect(() => {
    recalculateDiscountOnPriceOrQuantityChange();
  }, [price]);

  useEffect(() => {
    updateDescription();
  }, [description]);

  const updateDescription = () => {
    serviceItem.Description = description;
  }

  return (
    <>
      {/* Add Comp Modal */}
      <ComplimentaryPopup
        open={showComplimentary}
        compType={compType}
        compTypeSetter={onChangeCompType}
        existItemComp={{ orderLevel: false }
        }
        closeComplimentary={handleCloseComplimentary}
        countryInfo={countryInfo}
        addComp={addComp}
        compValue={compValue}
        removeCompItem={removeComp}
        compValueSetter={setCompValue}
        maxLimit={maxPrice}
      />
      <Grid flex="1" className="card white-bg mb-1">
        <Grid container xs={12} padding="10px 0 0 0">
          <Grid xs={1} alignSelf="start" className="remove-icon" sx={{ paddingLeft: "10px" }}>
            <Stack direction="row" alignItems="center">
              <Tooltip title="Remove" placement="bottom">
                <Button onClick={handleRemove} className="remove-btn">
                  <DeleteForeverRoundedIcon style={{ color: "#ff0000" }} />
                </Button>
              </Tooltip>

              {serviceItem?.InclusiveOfTax && isEditProductVisible && Utils.IsNullOrEmptyArray(serviceItem.PackageProductDetails) &&
                <Tooltip title="Edit" placement="bottom">
                  <Button onClick={(e) => handleEdit(serviceItem)} className="remove-btn">
                    <ModeEditOutlineIcon />
                  </Button>
                </Tooltip>
              }
              {branch.issueApprovalRequired && visitType === VisitTypeEnum.Jobcard && serviceItem.IssueApprovalRequired &&
                <Tooltip title={`Spare issue - ${serviceItem?.IssueStatus || ProductIssueStatus.Pending}`} placement="bottom">
                  <Button className="remove-btn">
                    {serviceItem.IssueStatus === ProductIssueStatus.Rejected ? <CloseIcon style={{ color: "#ff0000" }} /> :
                      serviceItem.IssueStatus === ProductIssueStatus.Approved ? <TaskAltIcon style={{ color: "#8BC34A" }} /> :
                        <ErrorIcon style={{ color: "rgb(255 152 0)" }} />
                    }
                  </Button>
                </Tooltip>}
            </Stack>
          </Grid>
          <Grid xs={11} sm={3} md={3} lg={3} alignSelf="center">
            {(!isFromPurchaseOrder && !isFromProductIntakes) ? (
              <TextField
                level="h2"
                className="h2 font-size-14 inputField "
                component="h4"
                fontWeight="600"
                value={description}
                multiline
                fullWidth
                onChange={(e) => setDescription(e.target.value)}
              />) : (
              <Typography
                level="h2"
                className="h2 font-size-14"
                component="h4"
                fontWeight="600"
                fullWidth
              >
                {description}
              </Typography>
            )}
            < Typography variant="h4" className="font-size-14" >
              {!Utils.IsNullOrEmptyArray(packagesProductDetails) && (
                <ul className="package">
                  {packagesProductDetails.map((item, index) => (
                    <li key={index}>{item.ShortDesc}
                      {(item.OnOrderQuantity ?? 0) > 1 && (
                        <span style={{ color: '#4a6684', marginLeft: "1rem" }}>{`-${item.OnOrderQuantity} nos`}</span>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </Typography>
          </Grid>
          <CostComponent
            cost={cost}
            currency={countryInfo.Currency}
            handleActions={handleCost}
          />
          {<HSNComponent
            HSN={HSN}
            handleActions={handleHsnvalue}
            serviceItem={serviceItem}
          />}
          {isFromProductIntakes && <BrandNameComponent
            brandName={brandName}
            handleActions={handleBrandName}
          />}
          <PriceComponent
            price={price}
            currency={countryInfo.Currency}
            handleActions={handlePrice}
          />
          <QuantityComponent
            quantity={quantity}
            handleActions={handleQuantity}
          />
          <Grid
            xs={4}
            sm={1} md={1} lg={1}
            justifyContent="Center"
            style={{ display: "flex", alignSelf: "center" }}
          >
            {isDiscount && (Utils.ConvertToFloat(price) > 0 || isFromProductIntakes) && (
              <Grid style={{ marginLeft: "4px" }}>
                {isViewDiscountIcon && (
                  <label
                    className="btn"
                    title="Add Discount"
                    style={{ "align-self": "center" }}
                    onClick={() => setShowComplimentary(true)}
                  >
                    <CardGiftcardIcon
                      style={{ "font-size": "24px", color: "#9c27b0" }}
                    />
                  </label>
                )}

                {!isViewDiscountIcon &&
                  !Utils.IsNullOrEmptyObject(currentComp) && (
                    <Stack direction="row" sx={{ position: "relative" }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                        sx={{ position: "relative" }}
                        className="discount-field"

                      >
                        {" "}
                        {currentComp.type === OfferTypes.PercentDiscount ? (
                          <Typography
                            level="h6"
                            component="h6"
                            fontWeight="700"
                            fontSize="12px"
                            className="currency-symbol"
                            style={{ padding: "0", right: "20px" }}
                          >
                            <label style={{ margin: "0", padding: "0" }}>%</label>
                          </Typography>
                        ) : (
                          <Typography
                            level="h6"
                            component="h6"
                            fontWeight="700"
                            fontSize="12px"
                            className="currency-symbol"
                            style={{ padding: "0", left: "10px" }}
                          >
                            <label style={{ margin: "0", padding: "0" }}>
                              {getSymbolFromCurrency(countryInfo.Currency)}
                            </label>
                          </Typography>
                        )}
                        <CompValueEntryField
                          label=""
                          type="text"
                          alignSelf="center"
                          variant="outlined"
                          value={currentComp.value}
                          setValue={onChangeCompValue}
                          maxLimit={maxPrice}
                          compType={currentComp.type}
                          className="inputField text-center-all"
                          style={{ margin: 0 }}
                        />
                      </Stack>
                      <Button onClick={() => removeComp(0)} className="btn discount-remove-btn">
                        <CloseIcon />
                      </Button>
                    </Stack>
                  )}
              </Grid>
            )}
          </Grid>

          {(Utils.ConvertToFloat(price) === 0 && !isFromProductIntakes) && (
            <Grid
              xs={4}
              lg={1}
              justifyContent="Center"
              alignItems="center"
              style={{ display: "flex" }}
            >
              <Typography>0</Typography>
            </Grid>
          )}
          {!isFromProductIntakes && <Grid
            xs={12}
            sm={1} md={1} lg={1}
            className="text-center mt-xs-1"
            alignSelf="center"
          >
            {branch.isAllowMunicipalTax && !isFromPurchaseOrder && !isFromProductIntakes && <Stack direction="row" justifyContent="end">
              <small className="visible-xs">Municipal Tax : &nbsp;</small>
              <Typography
                level="h4"
                component="h4"
                fontWeight="600"
                fontSize="14px"
              >
                {branch.municipalTax.toFixed(2) + "%"}
              </Typography>
            </Stack>}
          </Grid>}
          <Grid
            xs={12}
            sm={1} md={1} lg={1}
            className="text-center mt-xs-1"
            alignSelf="center"
            sx={{ paddingRight: "10px" }}
          >
            {branch.isTaxBracket === false && !isFromPurchaseOrder && isTaxIncludedInvoice && (
              <Stack direction="row" justifyContent="end" style={{ marginLeft: "2px" }}>
                <small className="visible-xs">Tax Percent : &nbsp;</small>
                {!isIndianBusiness && <Typography
                  level="h4"
                  component="h4"
                  fontWeight="600"
                  fontSize="14px"
                >
                  {Utils.IsNullOrEmpty(serviceItem.TaxPercent) || !taxIncluded
                    ? 0 + "%"
                    : serviceItem.TaxPercent.toFixed(2) + "%"}
                </Typography>}
                {isIndianBusiness && <Stack direction="row" alignItems="center">
                  {/* <Typography
                    level="h6"
                    component="h6"
                    fontWeight="700"
                    fontSize="12px"
                    className="currency-symbol"
                    style={{ marginRight: "15px" }}
                  >
                    %
                  </Typography> */}
                  <DecimalEntryField
                    fontWeight="600"
                    setValue={handleEditTax}
                    className="inputField text-right"
                    padding="0"
                    sx={{
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                      overflowWrap: "break-word"
                    }}
                    style={{ "max-width": "150px", margin: 0 }}
                    value={Utils.IsNullOrEmpty(serviceItem.TaxPercent) || !taxIncluded
                      ? 0
                      : Number.isInteger(serviceItem.TaxPercent)
                        ? serviceItem.TaxPercent
                        : serviceItem.TaxPercent.toFixed(2)}
                    convertToFloat={false}
                  />
                </Stack>}
              </Stack>
            )}
          </Grid>
          <Stack direction="row" justifyContent="space-between" alignItems="Center" className="text-right" sx={{ "width": "100%", "padding": "2px 10px", "margin-top": "10px", "background": "#f4f4f4 !important" }} alignSelf="center">
            <Stack direction="row" alignItems="Center">
              <ProductCodeComponent
                productCode={productCode}
                handleActions={handleProductCode}
              />

              {serviceItem?.InclusiveOfTax && isEditProductVisible &&
                <Stack direction="row" alignItems="center" margin="0 10px">
                  <Chip label="Inclusive of Tax" className="font-size-12" />
                </Stack>
              }
            </Stack>
            <Stack direction="row" justifyContent="end" alignItems="center">
              <small>Total Item Price : &nbsp;</small>
              {(branch.isTaxBracket) ? (<Typography
                level="h4"
                component="h4"
                fontWeight="600"
                fontSize="16px"
                sx={{
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  overflowWrap: "break-word"
                }}
              >
                {Utils.GetCurrency(
                  (serviceItem.TotalPrice + serviceItem.MunicipalTaxAmount),
                  countryInfo,
                  2
                )}
              </Typography>) : (<Typography
                level="h4"
                component="h4"
                fontWeight="600"
                fontSize="16px"
                sx={{
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  overflowWrap: "break-word"
                }}
              >
                {Utils.GetCurrency(taxIncluded ?
                  serviceItem.TotalPriceIncludingTax : (serviceItem.TotalPriceIncludingTax - serviceItem.TaxAmount),
                  countryInfo,
                  2
                )}
              </Typography>)}

            </Stack>
          </Stack>
        </Grid>
        {isDiscount && Utils.ConvertToFloat(price) > 0 &&
          !Utils.IsNullOrEmptyArray(serviceItem.Discounts) &&
          !Utils.IsNullOrEmptyArray(
            serviceItem.Discounts.filter(
              (d) =>
                !d.OrderLevel &&
                d.Complimentary &&
                itemComplimentaryList
                  .map((i) => i.compId)
                  .includes(d.CampaignId)
            )
          ) &&
          serviceItem.Discounts.filter(
            (d) =>
              !d.OrderLevel &&
              d.Complimentary &&
              itemComplimentaryList.map((i) => i.compId).includes(d.CampaignId)
          ).map((discount) => (
            <ItemDiscountComponent discount={discount}
              countryInfo={countryInfo} />
          ))}
      </Grid >
    </>
  );
};
export default ServiceItem;
